module.exports = __webpack_public_path__ + "static/media/old-west.fe9f5a28.jpg";